import Swal from 'sweetalert2';

// Custom SweetAlert2 configurations following user rules (no alert(), use SWAL)
export const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const showSuccess = (message: string) => {
  return Toast.fire({
    icon: 'success',
    title: message,
  });
};

export const showError = (message: string) => {
  return Toast.fire({
    icon: 'error',
    title: message,
  });
};

export const showWarning = (message: string) => {
  return Toast.fire({
    icon: 'warning',
    title: message,
  });
};

export const showInfo = (message: string) => {
  return Toast.fire({
    icon: 'info',
    title: message,
  });
};

export const confirmAction = (options: {
  title: string;
  text: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: 'warning' | 'question' | 'info' | 'error' | 'success';
  confirmButtonColor?: string;
  cancelButtonColor?: string;
}) => {
  return Swal.fire({
    title: options.title,
    text: options.text,
    icon: options.icon || 'question',
    showCancelButton: true,
    confirmButtonColor: options.confirmButtonColor ?? '#1E3A5F',
    cancelButtonColor: options.cancelButtonColor ?? '#6c757d',
    confirmButtonText: options.confirmButtonText || 'Confirm',
    cancelButtonText: options.cancelButtonText || 'Cancel',
  });
};

export const confirmDelete = (itemName: string) => {
  return confirmAction({
    title: 'Are you sure?',
    text: `You are about to delete ${itemName}. This action cannot be undone.`,
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
  });
};

/** When automatic clipboard copy fails, show the value so the user can copy manually. */
export const showTextForManualCopy = (title: string, value: string) => {
  return Swal.fire({
    title,
    input: 'text',
    inputValue: value,
    showCancelButton: false,
    confirmButtonText: 'Close',
    didOpen: () => {
      const input = Swal.getInput();
      if (input) {
        input.focus();
        input.select();
      }
    },
  });
};

export const showLoading = (message: string) => {
  Swal.fire({
    title: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeLoading = () => {
  Swal.close();
};

